import Component from '../core/Component'
import throttle from 'lodash/throttle'
import { queryAll } from '../utils/dom'
import EventBus from '../core/EventBus'

export const STATES = {
    OPEN: 'is-open',
    READY: 'is-ready',
    DEFAULT: 'is-default',
    INNERLINK_ACTIVE: 'is-innerlink-active',
}

export const defaults = {
    open: null,
    emit: null,
}

export default class StoreCategories extends Component {
    constructor(element) {
        super(element, defaults)

        this.ref = {
            content: null,
        }

        this.callbacks = {
            onClose: [],
            onOpen: [],
        }

        this.hasClosed = false

        this.handleResize = throttle(this.handleResize, 200)
    }

    prepare() {
        if (this.options.open === null && this.element.classList.contains(STATES.DEFAULT)) {
            this.options.open = this.element.offsetHeight > 0
            this.element.classList.remove(STATES.DEFAULT)
        }

        if (this.options.open) {
            this.open()
        } else {
            this.close()
        }

        this.element.addEventListener('click', this.handleClick)
        this.element.classList.add(STATES.READY)
        window.addEventListener('resize', this.handleResize)
    }

    destroy() {
        document.removeEventListener('click', this.handleOuterClick)
        window.removeEventListener('resize', this.handleResize)
    }

    handleClick = (event) => {
        const target = event.target.closest('a')

        if (target && this.options.emit) {
            event.preventDefault()
            this.emit('click', {
                id: target.id || target.dataset.id,
                name: target.textContent,
            })

            EventBus.emit('store:category:click', {
                id: target.id || target.dataset.id,
                name: target.textContent,
            })
        }

        if (target && target.dataset.type !== 'all') {
            this.close()
        }
    }

    handleOuterClick = (event) => {
        if (this.options.open && !this.hadClosed) {
            return
        }

        if (!this.element.contains(event.target)) {
            this.close()
        }
    }

    handleResize = () => {
        if (!this.is(STATES.OPEN)) {
            return
        }

        this.resize()
    }

    toggle() {
        if (this.is(STATES.OPEN)) {
            this.close()
        } else {
            this.open()
        }
    }

    open() {
        this.element.classList.add(STATES.OPEN)
        const height = Math.round(this.ref.content.getBoundingClientRect().height) + 60
        this.element.style.height = `${height}px`
        this.emit('open')
        document.addEventListener('click', this.handleOuterClick)
    }

    close() {
        this.element.classList.remove(STATES.OPEN)
        this.element.style.height = '0px'
        this.emit('close')
        this.hadClosed = true
        document.removeEventListener('click', this.handleOuterClick)
    }

    resize() {
        const height = Math.round(this.ref.content.getBoundingClientRect().height) + 60
        this.element.style.height = `${height}px`
    }
}
